"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPreviousMonthMemoLast;
var getPreviousMonthMemoKey;
var getPreviousMonthMemoValue;

function getPreviousMonthMemoLast(month) {
  if (month !== getPreviousMonthMemoKey) {
    getPreviousMonthMemoKey = month;
    getPreviousMonthMemoValue = month.clone().subtract(1, 'month');
  }

  return getPreviousMonthMemoValue;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/utils/getPreviousMonthMemoLast.js
 ** module id = 1043
 ** module chunks = 0
 **/